import EventIndex from '@components/EventIndex';
import { createStaticPropsFetcher } from '@lib/fetch/getStaticProps';
import type { GetStaticProps, NextPage } from 'next';

const EventIndexView: NextPage = () => <EventIndex />;

export const getStaticProps: GetStaticProps = createStaticPropsFetcher('eventIndex');

export default EventIndexView;
